import Accordion from 'bootstrap/js/dist/collapse';

const accordions = document.querySelectorAll('.accordion-container');

Array.from(accordions).forEach((accordion) => {
    const locationHash = location.hash;
    const accordionId = accordion.id;
    const accordionEl = accordion.querySelector('.accordion');
    const header = accordion.querySelector('.accordion__header');
    const arrowText = header.querySelector('span');
    const collapse = accordion.querySelector('.accordion__collapse');
    let textOpen = header.getAttribute('data-text-btn-open');
    let textClose = header.getAttribute('data-text-btn-close');

    if (collapse) {
        header.addEventListener('click', () => {
            accordionEl.classList.remove('is-open');
            arrowText.textContent = textOpen;
            let isExpanded = header.getAttribute('aria-expanded');
            
            if (!header.classList.contains('collapsed')) {
                accordionEl.classList.add('is-open');
                arrowText.textContent = textClose;
            }

            // Scroll accordion container when is open
            if (isExpanded === 'true') {
                collapse.addEventListener('transitionend', () => {
                    accordion.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    })
                }, {
                    once: true
                });
            }
        });
    }
});